import type { ReactElement } from "react";
import { memo } from "react";

import type { TIconProps } from "../types";

const MicrosoftTodoComponent = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.312,8.2,1.306,11.21a1.117,1.117,0,0,0,0,1.579l4.585,4.585,4.585-4.585L5.891,8.2A1.117,1.117,0,0,0,4.312,8.2Z"
      fill="hsl(from hsl(219 68% 48%) h s 42%)"
    />
    <path
      d="M22.652,6.625,19.645,3.619a1.115,1.115,0,0,0-1.578,0l-3.8,3.8h0L9.686,12h0L5.891,15.8a1.117,1.117,0,0,0,0,1.579L8.9,20.38a1.117,1.117,0,0,0,1.579,0l3.8-3.795h0L18.856,12l3.8-3.8A1.117,1.117,0,0,0,22.652,6.625Z"
      fill="hsl(from hsl(219 68% 48%) h s 59%)"
    />
    <rect x="-0.021" width="24" height="24" fill="none" />
  </svg>
);

// NOTE: Memoized per the repo's mandatory-memoization rule for exported
// components. These icons re-render on every parent render otherwise, and their
// props (className, aria-*) are stable across almost all of them.
export const MicrosoftTodo = memo(MicrosoftTodoComponent);
